<app-navigation>
  <router-outlet></router-outlet>
</app-navigation>
<!--<dock-privacy-settings></dock-privacy-settings>-->
